import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { pad } from "lodash";

const Register = () => {
  const navigate = useNavigate();
  const [getRolesList, setRolesList] = useState([]);
  const [getDepartmentAndDeviceList, setDepartmentAndDeviceList] = useState([]);
  const [getDeviceList, setDeviceList] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    roleId: "",
    profile: null,
  });

  // ✅ FIXED: State to hold userDetails safely after checking localStorage
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/logout");
      return;
    }

    try {
      const parsedUser = JSON.parse(storedUser);
      if (!parsedUser.token) {
        navigate("/logout");
        return;
      }
      setUserDetails(parsedUser); // ✅ Save safely into state
    } catch (err) {
      console.error("Invalid user object in localStorage");
      navigate("/logout");
    }
  }, [navigate]);

  useEffect(() => {
    if (userDetails && userDetails.token) {
      fetchData(userDetails.token);
      fetchDepartmentsData(userDetails.token);
    }
  }, [userDetails]);

  const fetchData = (token) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}get-roles`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.result.length > 0) {
          setRolesList(response.data.result);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const fetchDepartmentsData = (token) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}get-devices`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setDepartmentAndDeviceList(response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleDeviceCheckboxChange = (deviceId) => {
    setDeviceList((prevList) => {
      if (prevList.includes(deviceId)) {
        return prevList.filter((id) => id !== deviceId);
      } else {
        return [...prevList, deviceId];
      }
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      profile: e.target.files[0],
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.profile ||
      !formData.roleId ||
      !formData.password
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("password", formData.password);
    formDataToSend.append("roleId", formData.roleId);
    getDeviceList.forEach((deviceId) =>
      formDataToSend.append("device[]", deviceId)
    );

    if (formData.profile) {
      formDataToSend.append("profile", formData.profile);
    }

    const isFileUpload = !!formData.profile;
    const payload = isFileUpload
      ? formDataToSend
      : {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          password: formData.password,
          roleId: formData.roleId,
          device: getDeviceList,
        };

    const config = {
      headers: {
        Authorization: `Bearer ${userDetails.token}`,
        "Content-Type": isFileUpload
          ? "multipart/form-data"
          : "application/json",
      },
    };

    axios
      .post(process.env.REACT_APP_BASE_URL + "register", payload, config)
      .then((response) => {
        console.log("Response:", response);
        toast.success("Registration successful!");

        // Clear the form fields after success
        setFormData({
          name: "",
          email: "",
          phone: "",
          password: "",
          roleId: "",
          profile: null,
        });
        setDeviceList([]);

        const fileInput = document.querySelector('input[name="profile"]');
        if (fileInput) fileInput.value = "";
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || "Registration failed";
        toast.error(errorMessage);
        console.error("Error details:", error.response?.data || error);
      });
  };

  return (
    <>
      <ToastContainer />
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex justify-content-between">
                  <h6 className="m-0 font-weight-bold text-primary">
                    User Register
                  </h6>
                </div>
                <div className="card-body">
                  <div className="card-body p-0">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="p-5">
                          <div className="text-center">
                            <h1 className="h4 text-gray-900 mb-4">
                              Create an Account!
                            </h1>
                          </div>
                          <form className="user" onSubmit={handleSubmit}>
                            <div className="form-group row">
                              <div className="col-sm-6 mb-3 mb-sm-0">
                                <label htmlFor="name" className="form-label">
                                  Name:
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  name="name"
                                  placeholder="User Name"
                                  value={formData.name}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                              <div className="col-sm-6">
                                <label htmlFor="name" className="form-label">
                                  Profile:
                                </label>
                                <input
                                  type="file"
                                  className="form-control form-control-user file"
                                  name="profile"
                                  style={{
                                    lineHeight: "1",
                                    display: "inline-block",
                                    padding: "12px 20px 30px 13px",
                                    cursor: "pointer",
                                  }}
                                  onChange={handleFileChange}
                                />
                              </div>
                            </div>

                            <div className="form-group row">
                              <div className="col-sm-6 mb-3 mb-sm-0">
                                <label htmlFor="name" className="form-label">
                                  Email:
                                </label>
                                <input
                                  type="email"
                                  className="form-control form-control-user"
                                  name="email"
                                  placeholder="Enter Email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                              <div className="col-sm-6 mb-3">
                                <label htmlFor="name" className="form-label">
                                  Roles:
                                </label>
                                <select
                                  className="form-select form-select-lg form-control form-control-user1 role-select"
                                  name="roleId"
                                  value={formData.roleId}
                                  onChange={handleInputChange}
                                  required
                                >
                                  <option value="" disabled>
                                    Select Role
                                  </option>
                                  {getRolesList.map((role, index) => (
                                    <option key={index} value={role._id}>
                                      {role.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-sm-6 mb-3">
                                <label htmlFor="name" className="form-label">
                                  Phone Number:
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  name="phone"
                                  placeholder="Phone Number"
                                  value={formData.phone}
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col-sm-6 mb-3">
                                <label htmlFor="name" className="form-label">
                                  Password:
                                </label>
                                <input
                                  type="password"
                                  className="form-control form-control-user"
                                  name="password"
                                  placeholder="Password"
                                  value={formData.password}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>

                              {getDepartmentAndDeviceList?.devices?.map(
                                (device, index) => (
                                  <div
                                    className="col-sm-3 form-check pl-5"
                                    key={index}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`device-checkbox-${device._id}`}
                                      checked={getDeviceList.includes(
                                        device._id
                                      )}
                                      onChange={() =>
                                        handleDeviceCheckboxChange(device._id)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`device-checkbox-${device._id}`}
                                    >
                                      {device.name}
                                    </label>
                                  </div>
                                )
                              )}
                            </div>
                            <button
                              type="submit"
                              className="btn btn-primary btn-user btn-block"
                            >
                              Register Account
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="sticky-footer bg-white">
            <div className="container my-auto">
              <div className="copyright text-center my-auto">
                <span>Copyright &copy; Blue Iris Software Trading LLC</span>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Register;
